import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actions from "./../../../../actions/resetPassword.actions";
import * as commonActions from "./../../../../actions/common.actions";
import ResetPassword from "../components/ResetPassword";

class ResetPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getQueryVariable = this.getQueryVariable.bind(this);
  }

  componentWillUnmount() {
    this.props.commonActions.showError(null);
  }

  getQueryVariable(variable) {
    const query = this.props.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return "";
  }

  handleSubmit(data) {
    const params = { ...data, ...{ token: this.getQueryVariable("token") } };
    this.props.actions.resetPassword(params);
  }

  render() {
    return (
      <ResetPassword
        onSubmit={this.handleSubmit}
        location={this.props.location}
      />
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/routes/common/resetPassword/containers/ResetPasswordContainer.js